import Cookies from "universal-cookie";
import React, { useState, useEffect } from "react";
import Cookie from "universal-cookie";
import DeliveryCycleInfo from "@tw/shared-ui-components/lib/components/variantDrawerDeliveryCycleInfo/variantDrawerDeliveryCycleInfo";
export const ROLE_FOA = "FOA";
export const getPdmApiUrl = () => {
  return (
    (typeof window === "undefined" ? process.env : window.appConfig || {})
      .PDM_BFF_API || "http://localhost:3002"
  );
};
export const getPurchaseApiUrl = () =>
  (typeof window === "undefined" ? process.env : window?.appConfig || {})
    .PURCHASE_BFF_API || "http://localhost:3001";

export const getRouter = () => {
  if (typeof window === "undefined") return {};
  return window.useRouter && window.useRouter();
};

export const getParams = () => {
  if (typeof window === "undefined") return {};
  if (window.useParams) {
    if (window.useLocation)
      return {
        ...window.useParams(),
        ...getQueryStringParams(window.useLocation().search),
      };
    return window.useParams();
  }
  return {};
};

export const getParameterByName = (name, url) => {
  name = name.replace(/[\[\]]/g, "\\$&"); // eslint-disable-line
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const getRenderFormat = (data, type) => {
  switch (type) {
    case "richText":
      return data;
    case "image":
      return `<img src=${data} />`;
    case "video":
      return `<video controls>
        <source src=${data} type="video/mp4">
  <source src=${data} type="video/ogg">
  Your browser does not support the video tag.
      </video>`;
    default:
      return data;
  }
};

//----------------------------

export const useParamas = () => {
  const [params, setParams] = useState({});
  if (typeof window === "undefined") return {};
  const routeParams = window.useParams?.() || {};
  const { search } = window.useLocation?.() || {};
  useEffect(() => {
    setParams({
      ...routeParams,
      ...getQueryStringParams(search),
    });
  }, [routeParams, search]);
  return { params };
};

//-----------------------
const getQueryStringParams = (query) => {
  if (!query) return {};
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
      .split("&")
      .reduce((params, param) => {
        let [key, value] = param.split("=");
        params[key] = value
          ? decodeURIComponent(value.replace(/\+/g, " "))
          : "";
        return params;
      }, {})
    : {};
};

//don't remove this comment

/* const getQueryStringParams = (query) => {
  if (!query) return {};
  if (query)
    return (/^[?#]/.test(query) ? query.slice(1) : query)
      .split("&")
      .reduce((params, param) => {
        let [key, value] = param.split("=");
        params[key] = value
          ? decodeURIComponent(value.replace(/\+/g, " "))
          : "";
        return params;
      }, {});
  return {};
}; */

export const getLoggedInUserInfo = () => {
  if (typeof window === "undefined") return {};

  const cookie = new Cookies();

  const role = cookie.get("role") || "Guest";
  const loginAda = cookie.get("ada") || "";
  const accessToken = cookie.get("accessToken") || "";

  return { role, loginAda, accessToken };
};

const deliveryDescriptionArray = [
  "單月配送意指以一個月為配送週期，配送當月份量之產品",
  "雙月配送意指以兩個月為配送週期，配送兩個月之份量產品",
];

const enumeration = {
  1: ['', '單月配送意指以一個月為配送週期，配送當月份量之產品'],
  2: ['', '隔月配送意指以兩個月為配送週期，配送一個月份量之產品', '雙月配送意指以兩個月為配送週期，配送兩個月之份量產品']
}
const bindFilterateProduct = (product) => {
  if (!product) return deliveryDescriptionArray
  const { sop_delivery_frequency_period, sop_frequency_switch } = product?.info;
  if (sop_delivery_frequency_period && sop_delivery_frequency_period?.value && sop_frequency_switch && (sop_frequency_switch?.value == "Open" || sop_frequency_switch?.value == "open")) {
    const deliveryFrequencyPeriod = JSON.parse(sop_delivery_frequency_period?.value);
    let deliveryIntroductionArray = []
    for (let index in deliveryFrequencyPeriod) {
      deliveryFrequencyPeriod[index].map((item) => {
        deliveryIntroductionArray.push(enumeration[index][item.period])
      })
    }
    return deliveryIntroductionArray
  } else {
    return deliveryDescriptionArray
  }
}
export const renderDeliveryInfo = (product) => (
  <DeliveryCycleInfo deliveryDescriptionArray={bindFilterateProduct(product)} />
);
// Object for product status
const productStatusObj = {
  buyAhead: {
    label: "預售",
    colorCode: "#D91734",
    actionType: "AddToCart",
    isActionEnabled: true,
  },
  upcoming: {
    label: "尚未上市",
    colorCode: "#D91734",
    actionType: "AddToCart",
    isActionEnabled: false,
  },
  outOfStock: {
    label: "暫停供貨",
    colorCode: "#D91734",
    // actionType: "NotifyMe",
    // isActionEnabled: true,
    actionType: "AddToCart",
    isActionEnabled: false,
  },
  notForSale: {
    label: "暫停供貨",
    colorCode: "#D91734",
    // actionType: "NotifyMe",
    // isActionEnabled: true,
    actionType: "AddToCart",
    isActionEnabled: false,
  },
};

export const getProductStatus = (product) => {
  const productStatus = product?.productStatus?.toLowerCase();
  if (productStatus === "buyahead") {
    return productStatusObj.buyAhead;
  } else if (productStatus === "upcoming") {
    return productStatusObj.upcoming;
  } else if (productStatus === "outofstock") {
    return productStatusObj.outOfStock;
  } else if (productStatus === "notforsale") {
    return productStatusObj.notForSale;
  }
};

export const isAddToCartDisabled = (productStatus) =>
  ["upcoming", "outOfStock", "notForSale"].includes(productStatus);

export const getNonStrictVariantsLS = () => {
  if (typeof window === "undefined") return {};
  return JSON.parse(localStorage.getItem("AMW_NON_STRICT_VARIANTS")) || {};
};
export const setNonStrictVariantsLS = (nonStrictVariants) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(
    "AMW_NON_STRICT_VARIANTS",
    JSON.stringify(nonStrictVariants)
  );
};
// TEP-13308、TEP-13256 印度团队原有代码中 categories 数组数据排序倒转了，现在新增 reverse()方法重置顺序
//  TEP-15800
export const getPageDetails = (navigation, type) => {
  const categories =
    navigation != null &&
    navigation.reduce((reversed, cat) => [cat, ...reversed], []).reverse();
  if (categories && categories.length > 0) {
    const categoryIndex = categories.length >= 2 ? categories.length - 2 : categories.length - 1;
    const subCategoryIndex = categories.length - 1;
    const category = categories[categoryIndex].categoryCode == "root" ? "root" : categories[categoryIndex].categoryNameEn
    const subCategory = categories[subCategoryIndex].categoryCode == "root" ? "root" : categories[subCategoryIndex].categoryNameEn
    return {
      ...(categories?.length > 0
        ? {
          category: category,
          subCategory: subCategory,
        }
        : {}),
      ...(type ? { type } : {}),
    };
  } else {
    return {
      ...(type ? { type } : {}),
    };
  }


};

export const getPageHeadTags = (title, description) => {
  if (title || description) {
    return (
      <>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta name="robots" content="noodp,noydir" />
      </>
    );
  }
  return null;
};
export const getCommonParameters = () => {
  if (typeof window === "undefined")
    return {
      loginAda: "",
      loginMemberType: "",
      loginType: "",
      bizCode: "",
      channelCode: "",
    };

  const cookie = new Cookie();
  const isVisitor = getVisitorStatus();

  if (isVisitor) {
    return {
      loginAda: cookie.get("vAda") || "",
      loginMemberType: ROLE_FOA || "",
      loginType: "V" || "",
    };
  } else {
    return {
      loginAda: cookie.get("ada") || "",
      loginMemberType: cookie.get("role") || "",
      loginType: cookie.get("loginType") || "",
    };
  }
};

export const getVisitorStatus = () => {
  const cookie = new Cookie();
  if (cookie.get("vAda") && !cookie.get("ada")) {
    return true;
  } else {
    return false;
  }
};

export const getFullRoute = () =>
  typeof window !== "undefined" ? window.location.href : process.fullRoute;

export const getOrigin = () =>
  typeof window !== "undefined" ? window.location.origin : process.origin;
